import { IEditHistoryEntry } from '@typings/editHistory.interface';

const MAX_HISTORY = 5;

/** HTML 태그 제거 후 공백 정리 */
function stripHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&[a-zA-Z]+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * 수정 히스토리 엔트리를 배열에 추가 (최대 5건 FIFO)
 * - docId/commentId가 있는 경우(수정 모드)에서만 호출할 것
 */
export function appendEditHistory(
  prevHistory: IEditHistoryEntry[] | undefined,
  editedBy: string,
  editedByName?: string,
  content?: string,
): IEditHistoryEntry[] {
  const newEntry: IEditHistoryEntry = {
    editedBy,
    editedAt: new Date(),
    ...(editedByName ? { editedByName } : {}),
    ...(content ? { contentPreview: stripHtml(content) } : {}),
  };
  const updated = [...(prevHistory || []), newEntry];
  return updated.length > MAX_HISTORY ? updated.slice(-MAX_HISTORY) : updated;
}
